// extracted by mini-css-extract-plugin
export default {"invalidDataError":"Orders_invalidDataError__4t1Ix"};